import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ICapability, ICapabilityAssignRemove, ICapabilityForm } from "../models/capabilities";

@Injectable({
  providedIn: "root",
})
export class CapabilityService {
  private baseurl: string = "/capability";

  public list: ICapability[] = [];

  constructor(private _httpClient: HttpClient) {}

  async getList() {
    return this._httpClient
      .get<ICapability[]>(this.baseurl)
      .toPromise()
      .then((response) => {
        this.list = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  async delete(id: number) {
    return this._httpClient
      .delete(this.baseurl + "/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async get(id: number) {
    return this._httpClient.get<ICapability>(this.baseurl + "/" + id).toPromise();
  }

  async create(data: ICapabilityForm) {
    return this._httpClient
      .post(this.baseurl, data)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async update(id: number, data: ICapabilityForm) {
    return this._httpClient
      .put(this.baseurl + "/" + id, data)
      .toPromise()
      .then(async () => {
        await this.getList();
      });
  }

  //Funzione che gestisce l'assegna dal form aggiungi/modifica permesso
  async assign_unssign(id: number, assign_role: Array<number>, unassign_role: Array<number>) {
    return this._httpClient
      .post(`${this.baseurl}/${id}/assign-unassign`, { assign_role, unassign_role })
      .toPromise()
      .then(async () => {
        await this.getList();
        return true;
      });
  }

  async batch_assign_unassign(data: ICapabilityAssignRemove | {}) {
    return this._httpClient.put("/capability/assign-remove", { roles: data }).toPromise();
  }
}
